import { render } from "./UniversalLogin.vue?vue&type=template&id=511bf99a"
import script from "./UniversalLogin.vue?vue&type=script&lang=js"
export * from "./UniversalLogin.vue?vue&type=script&lang=js"

import "./UniversalLogin.vue?vue&type=style&index=0&id=511bf99a&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__